module.exports = __webpack_public_path__ + "static/6305-woodrose-34-53aa8c5cb9b7737752b7414781bfba21.jpg";